<div class="content-block">
  <article class="article " style="margin-top:1rem">
    <div class="title-container">
      <button class="btn btn-back" (click)="back()"><i class="fas fa-caret-left"></i> Back</button>
      <div style="flex: 10;">
        <h2>Web User Management</h2>
      </div>
      <div style="flex:1;justify-content: flex-end;display: flex;">
        <div class="add" (click)="add()" *ngIf="!readOnly">
          <i class="fa fa-plus" aria-hidden="true"></i>
        </div>
      </div>

    </div>


    <form style="width: 100%;margin-top: 0.5rem;" (submit)="rebind()">
      <div class=" form-row borderless;" style="padding:0.5rem">

        <div class="col-md-3">
          <div class="form-group">
            <label>Companies</label>
            <app-company-picker [accountId]="filter.company_Id" [_placeholder]="'All'"
              (onCompanySet)="onCompanyChange($event)"></app-company-picker>
          </div>
        </div>

        <div class="col-md-3 col-sm-6">
          <label>Name</label>
          <input type="text" name="name" [(ngModel)]="filter.name" />
        </div>

        <div class="col-md-3 col-sm-6">
          <label>Email</label>
          <input type="text" name="email" [(ngModel)]="filter.email" />
        </div>
          <div class="col-md-3 col-sm-6">
            <label></label>
          <div class="btn-container" style="justify-content: flex-end;min-height: 57px;">

            <button class="btn btn-secondary" style="margin-right:1rem" (click)="resetFilters()">Reset</button>
            <button class="btn btn-primary" style="margin-right:1.25rem" value="Refresh">Refresh</button>
          </div>
        </div>
      </div>


    </form>

    <app-loading-icon *ngIf="loading"></app-loading-icon>
  </article>
  <article class="article " style="margin-top:1rem">

    <div class="form-column borderless" style="display: block;">

      <ngx-datatable [count]="page.totalElements" [offset]="page.pageNumber" [limit]="page.size" [headerHeight]="50"
        [footerHeight]="50" (page)='setPage($event)' (sort)="onSort($event)" class="material" [rows]="rows"
        [columnMode]="'force'" [externalPaging]="true" [externalSorting]="true" [rowHeight]="'auto'">


        <ngx-datatable-column name="Firstname" prop="firstname">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <div>{{ value }}</div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Lastname" prop="lastname">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <div>{{ value }}</div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Email" prop="email">
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            <div>{{ value }}</div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="User Type" prop="userType">
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            <div>{{ value }}</div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Company Name" prop="company_Name">
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            <div>{{ value }}</div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Option" *ngIf="!readOnly">
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            <a [routerLink]="['/users/manage', row.id]">Edit</a>
          </ng-template>
        </ngx-datatable-column>

      </ngx-datatable>
    </div>
  </article>
</div>